import React from 'react'
import { CButton } from 'compat/coreui';

export default function Gallary() {
    return (
        <>
            <ul className="c_8 timeline">
                <li id="new_post">
                    <div className="box add">
                    <h2>No photos have been added yet!</h2>
                        <span className="title">Photo Gallery</span>
                        <div className="textarea_wrap">
                            <form method="post" action="?action=new_post" id="new_post_form" encType="multipart/form-data" className="fu_form">
                                <div className="fu_wrap single" id="post_file">
                                    <div className="fileUpload btn btn-primary">
                                        <span>Upload</span>
                                        <input type="file" className="upload" />
                                    </div>
                                    <p>Tip: Click and drag photos to reorder your gallery. Your first photo is your profile photo</p>
                                </div>
                                <CButton color="success" size="lg">Save</CButton>
                            </form>
                        </div>
                    </div>
                </li>
            </ul>
        </>
    )
}